<template>
  <article
    :class="['mt-1', { 'container-fluid': !isMobile, 'mx-n3': isMobile }]"
  >
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div class="container-fluid py-3">
        <div class="row">
          <div
            v-if="disabled"
            class="col-12 col-md-4"
          >
          <div :class="['col-12', { 'col-md-8': disabled }]">
            <div
              :class="{
                'ml-3 chips-container': !isMobile,
                'mt-4': isMobile
              }"
            >
            <CustomChipsGroup
                title="Necesidad(es) Seleccionada(s)"
                object-text="name"
                :selected-items="items"
                :disabled="disabled"
                :no-background="true"
                :no-wrap="true"
                :on-item-deleted="remove"
              />
            </div>
          </div>
        </div>
        </div>
        </div>
    </ValidationObserver>
  </article>
</template>

<script>
import ActionButton from "ActionButton";
import CustomChipsGroup from "CustomChipsGroup";
import CustomDropDown from "custom-drop-down";
import {
  getAssistantServices,
  addAssistantService,
  removeAssistantService
} from "@/modules/human-resources/api.js";
import alert from "@/mixin/alert.mixin";

export default {
  name: "Necessities",
  mixins: [alert],
  components: {
    ActionButton,
    CustomChipsGroup,
    CustomDropDown
  },
  props: {
    contractNumber: {
      type: String,
      default: ""
    },
    selectionList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      itemToAdd: null
    };
  },
  computed: {
    model() {
      return this.value;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    availableSelectionList() {
      const selectableItems = this.selectionList.filter(
        itemToSelect =>
          !this.items.some(itemSelected => itemSelected.id == itemToSelect.id)
      );
      return selectableItems.sort((a, b) => {
        return a.id - b.id;
      });
    }
  },
  methods: {
    add() {
      addAssistantService(this.contractNumber, this.itemToAdd.id)
        .then(res => {
          if (res.status == 200) {
            this.items.push(this.itemToAdd);
            this.itemToAdd = null;
            this.$refs.itemToAddValidator.reset();
          }
        })
        .catch(this.onException);
    },
    remove(item) {
      removeAssistantService(this.contractNumber, item.id)
        .then(res => {
          if (res.status == 200) {
            const index = this.items.findIndex(e => e.id === item.id);
            this.items.splice(index, 1);
            this.$refs.itemToAddValidator.reset();
          }
        })
        .catch(this.onException);
    },
    onException(err) {
      if (err && err.response && err.response.data) {
        this.ShowToast("Error", err.response.data.message, "error");
      } else {
        this.ShowToast("Error", err.message, "error");
      }
    }
  },
  async mounted() {
    this.items = await getAssistantServices(this.contractNumber);
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.divider-horizontal {
  border-right: 1px solid map.get($colors, "gray-5");
  height: 100%;
}
.divider-vertical {
  border-bottom: 1px solid map.get($colors, "gray-5");
}
::v-deep .chips-container {
  padding-top: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  min-height: 89px !important;
  .mt-3 {
    margin-top: 0 !important;
  }
  .bold {
    margin-bottom: 0 !important;
    font-weight: 400 !important;
  }
  .label.label-default.chips {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }
}
::v-deep .student-search-alert-error {
  height: 0;
}
</style>
